<template>
  <div class="button-group">
    <button
      type="button"
      v-for="(option, index) in context.options"
      :key="index"
      :class="{
        btn: true,
        'btn-default': context.model !== option.value,
        'btn-primary': context.model === option.value
      }"
      @click="context.model = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>
<style scoped>
.button-group {
  display: flex;
}
.button-group button.btn {
  border-radius: 2px !important;
  border-color: #1994ce;
}

@media only screen and (max-width: 739px){
  .button-group button.btn {
    font-size: 13px !important;
    line-height: 1.3 !important;
    width: 50% !important;
    padding: 3px 0px !important;
    border-radius: 3px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ButtonGroup.vue